import { LabelPrinter } from "../LabelPrinter";
import { mapPrintApiConnectionType } from "../../shared/print-api/utils";
import { PrintApiPrinter } from "../../shared/print-api/types";

export class PrintApiLabelPrinter extends LabelPrinter {
  constructor(public device: PrintApiPrinter) {
    super(mapPrintApiConnectionType(device.connectionType));
  }

  // Override Peripheral getters to map from Print API service metadata
  get id(): string {
    return `print-api-${this.device.id}`;
  }

  override get name(): string {
    return this.device.name;
  }

  override get isConnected(): boolean {
    return false; // API printers are not "connected" in the traditional sense
  }

  override get vendorId(): number | undefined {
    return this.device.metadata.vendorId;
  }

  override get productId(): number | undefined {
    return this.device.metadata.productId;
  }

  get ipAddress(): string {
    return this.device.metadata.ipAddress;
  }

  get macAddress(): string | null {
    return this.device.metadata.macAddress;
  }

  // Connection methods (API printers don't actually connect/disconnect)
  override doConnect(): Promise<boolean> {
    return Promise.resolve(true);
  }

  override doDisconnect(): Promise<boolean> {
    return Promise.resolve(true);
  }

  // Label printer specific methods
  override print(_bytes: Uint8Array): Promise<boolean> {
    // Ignore. Cloud printers will pick up the job
    return Promise.resolve(true);
  }
}
